import React from "react";
import { Link, Navigate } from "react-router-dom";
import { AuthContext } from "./ContextProvider";
import { useSearchParams } from "react-router-dom";
import { loginIdproviderCallback } from "../backend.service";
import { AppBar, Toolbar } from "@mui/material";
import { useTheme } from "app/theme-context";

export const IdproviderCallback = () => {
    const [errorMessage, setErrorMessage] = React.useState<string>();
    const [toView, setToView] = React.useState<boolean>(false);
    const [sentMsg, setSentMsg] = React.useState<boolean>(false);
    const { cssProperties } = useTheme();

    const onLoad = async () => {
        const { user, setUser } = React.useContext(AuthContext);
        const [searchParams, setSearchParams] = useSearchParams();

        if (user) {
            setTimeout(() => {
                setToView(true);
            }, 1000);
            return;
        }

        if (sentMsg) {
            return;
        }

        try {
            setSentMsg(true);
            const loginResponse = await loginIdproviderCallback(searchParams);
            if (loginResponse && loginResponse.status == 200) {
                setUser(loginResponse.data);
                setToView(true);
            }
        } catch (err) {
            if (
                typeof err === "object" &&
                err !== null &&
                "response" in err &&
                typeof (err as any).response === "object" &&
                (err as any).response !== null &&
                "status" in (err as any).response &&
                (err as any).response.status === 401
            ) {
                setErrorMessage("Invalid credentials. Please try again.");
            } else {
                setErrorMessage(
                    "An error has occured. Please try again or contact an administrator."
                );
            }
        }
    };

    onLoad();

    return (
        <div>
            <AppBar position="static" color="default" style={cssProperties}>
                <Toolbar />
            </AppBar>
            <div
                style={{
                    width: "100%",
                    margin: "0 auto",
                    position: "absolute",
                    top: "50%",
                    msTransform: "translateY(-50%)",
                    transform: "translateY(-50%)"
                }}
            >
                {!errorMessage && (
                    <p style={{ textAlign: "center" }}>
                        Continuing the signing in using an identity provider...
                    </p>
                )}
                {errorMessage && (
                    <p style={{ textAlign: "center" }} className="text-danger">
                        {errorMessage} <br />
                        <Link to="/login">Return to login page</Link>
                    </p>
                )}
                {toView && <Navigate to="/view" />}
            </div>
        </div>
    );
};
